import { Creator } from '@/api/generatedApi';

export const getCreatorEmailValue = <T extends { creator?: Creator }>(_value: unknown, row: T): string => {
  return row.creator?.email ?? '';
};
